import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import Loading from "../../components/shared/Loading";

const Screen = lazy(() => import("../../views/error/Error500Page"));

export const Route = createFileRoute("/(open)/500")({
  component: RouteComponent,
  staticData: {
    routeKey: "internalServerError",
    access: "open",
    layout: "blank",
    container: "default",
  },
});

function RouteComponent() {
  return (
    <Suspense fallback={<Loading loading={true} />}>
      <Screen />
    </Suspense>
  );
}
